import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import useForm from 'react-hook-form';
import PropTypes from 'prop-types';
/* actions */
import {
  getAllCategories,
  addCategories
} from '../../redux/actions/categories';
/* components */
import ErrorMsgField from '../../components/ErrorMsgField';
import AlertMsg from '../../components/AlertMsg';
import FormFooter from '../../components/FormFooter';
import FormHeader from '../../components/FormHeader';
/* form-validation */
import schema from '../../form-validation/category';
/* utils */
import handleChangeDefault from '../../utils/handleChangeDefault';

function Add (props) {
  const { handleModalClose } = props;
  const dispatch = useDispatch();
  const submitButton = useRef();
  const { register, handleSubmit, errors, reset } = useForm({
    validationSchema: schema,
    reValidateMode: 'onSubmit'
  });
  const sessionUser = useSelector(state => state.authentications.user);
  const company = sessionUser.company._id;
  const categories = useSelector(state => state.categories);
  const INITIAL_VALUES = {
    name: '',
    description: '',
    company
  };
  const [data, setData] = useState(INITIAL_VALUES);

  useEffect(() => {
    dispatch(getAllCategories({ company }));
  }, [dispatch]);

  const submit = () => {
    const resetForm = () => {
      reset();
      setData({ ...INITIAL_VALUES });
    };
    const newData = {
      ...data,
      macroCategory: data.macroCategory ? data.macroCategory : null
    };
    dispatch(addCategories(newData, resetForm, submitButton.current));
  };

  return (
    <div className="container-fluid">
      {categories.addSuccess && (
        <AlertMsg type="success" msg="Categoria cadastrada com sucesso" />
      )}
      {categories.errorContent &&
        !categories.errorContent.message.includes('400') &&
        categories.addError && (
        <AlertMsg type="danger" msg="Falha durante cadastro da categoria" />
      )}
      {categories.errorContent &&
        categories.errorContent.message.includes('400') &&
        categories.addError && (
        <AlertMsg
          type="danger"
          msg="Uma categoria com o nome informado já está cadastrada"
        />
      )}
      {!categories.addSuccess && !categories.addError && (
        <AlertMsg type="info" msg="Área cadastro de categorias" />
      )}
      <FormHeader title="Cadastrar Categoria" />
      <form onSubmit={handleSubmit(submit)}>
        <div className="form-group">
          <label htmlFor="name">
            Nome<span className="field-required">*</span>
          </label>
          <input
            type="text"
            className="form-control"
            id="name"
            name="name"
            autoComplete="off"
            onChange={evt => handleChangeDefault(evt, data, setData)}
            value={data.name}
            ref={register}
          />
          {errors.name && errors.name.type === 'required' && (
            <ErrorMsgField type="required" />
          )}
        </div>
        <div className="form-group">
          <label htmlFor="description">
            Descrição<span className="field-required">*</span>
          </label>
          <textarea
            className="form-control"
            id="description"
            name="description"
            rows="3"
            onChange={evt => handleChangeDefault(evt, data, setData)}
            value={data.description}
            ref={register}
          ></textarea>
          {errors.description && errors.description.type === 'required' && (
            <ErrorMsgField type="required" />
          )}
        </div>
        {handleModalClose ? (
          <div className="container-fluid p-0">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={handleModalClose}
            >
              <i className="fa fa-times"></i>
              &nbsp;Fechar
            </button>
            <button
              type="submit"
              ref={submitButton}
              className="btn btn-primary float-right"
            >
              <i className="fa fa-save"></i>
              &nbsp;Salvar
            </button>
          </div>
        ) : (
          <FormFooter url="/categories" reference={submitButton} />
        )}
      </form>
    </div>
  );
}

Add.propTypes = {
  handleModalClose: PropTypes.func
};

export default Add;
